<template>
  <div class="privacy-container" v-loading="loadingData">
    <div class="privacy-card">
      <div class="privacy-title">隐私政策</div>
      <div class="privacy-content" v-html="privacyContent" />
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      privacyContent: "",
      loadingData: true
    };
  },
  created: function() {
    // 查询隐私政策
    this.loadPrivacyData();
  },
  methods: {
    async loadPrivacyData() {
      const res = await httpRequest("/app/setting/info", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.privacyContent = res.data.pricacyPolicy;
      }
      this.loadingData = false;
    }
  }
};
</script>

<style scoped lang="scss">
.privacy-container {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 30px auto 40px;
  
  .privacy-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
    padding: 60px 80px;

    .privacy-title {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e293b;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      
      &::after {
        content: '';
        display: block;
        width: 60px;
        height: 4px;
        background: #00b0ab;
        border-radius: 2px;
        margin: 16px auto 0;
      }
    }

    .privacy-content {
      min-height: 500px;
      text-align: left;
      font-size: 15px;
      line-height: 2.2;
      color: #334155;
      
      ::v-deep p {
        margin-bottom: 16px;
        text-align: justify;
      }
      
      ::v-deep strong, ::v-deep b {
        color: #0f172a;
        font-weight: 600;
      }
    }
  }
}
</style>
